import { Injectable } from '@angular/core';
import { SnotifyService } from 'ng-snotify';

@Injectable()
export class EclesialNotificationService {

    constructor(
        private snotifyService: SnotifyService,
    ) { }

    private snotifyNotifications: number[] = [];

    public notifyError(message: string) {

        this.snotifyService.error(message, {

            timeout: 4000,
            showProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,

        }).on('shown', (toast) => {

            if (this.snotifyNotifications.indexOf(toast.id) === -1) {
                this.snotifyNotifications.push(toast.id);
            }
        });
    }

    public notifyWarning(message: string) {

        this.snotifyService.warning(message, {

            timeout: 4000,
            showProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,

        }).on('shown', (toast) => {

            if (this.snotifyNotifications.indexOf(toast.id) === -1) {
                this.snotifyNotifications.push(toast.id);
            }
        });
    }

    public notifySuccess(message: string) {

        this.snotifyService.success(message, {

            timeout: 4000,
            showProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,

        }).on('shown', (toast) => {

            if (this.snotifyNotifications.indexOf(toast.id) === -1) {
                this.snotifyNotifications.push(toast.id);
            }
        });
    }

    public notifyHTML(message: string) {

        this.snotifyService.html(message, {

            timeout: 4000,
            showProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,

        }).on('shown', (toast) => {

            if (this.snotifyNotifications.indexOf(toast.id) === -1) {
                this.snotifyNotifications.push(toast.id);
            }
        });
    }

    public clear() {

        if (this.snotifyNotifications.length > 0) {
            this.snotifyService.clear();
            this.snotifyNotifications = [];
        }
    }
}